// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"1f4e3ca5","87":"ecb3f338","131":"0efc2895","146":"5b75f770","225":"b3239c54","264":"468689cd","425":"c4473254","453":"a157d6c9","456":"80126778","595":"4418df8f","638":"4167cb1b","672":"357899b4","755":"57fe59ec","849":"237615be","980":"c6a2970a"}[chunkId] + ".chunk.js";
};